export default __webpack_public_path__ + "static/media/up-arrow.692d147e.svg";